import React from "react";
import JobPhotosTab from "../shared/tabs/JobPhotosTab";

const TabContent = ({ activeTab, formData, onChange }) => {
  const renderTab = () => {
    const commonProps = {
      formData,
      onChange,
    };

    switch (activeTab) {
      case "job_photos":
        return React.createElement(JobPhotosTab, commonProps);
      default:
        return React.createElement("div", null, "Tab not found");
    }
  };

  return React.createElement("div", { className: "py-6" }, renderTab());
};

export default TabContent;
